import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb93ddde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "count" }
const _hoisted_2 = {
  key: 1,
  class: "footer"
}

import { nextTick, onMounted, ref, watch } from 'vue'
import { useMainStore } from '@/store'
import useSearch from '@/hooks/useSearch'
import MoveablePanel from '@/components/MoveablePanel.vue'
import Tabs from '@/components/Tabs.vue'
import Divider from '@/components/Divider.vue'
import Input from '@/components/Input.vue'
import Button from '@/components/Button.vue'

type TypeKey = 'search' | 'replace'
interface TabItem {
  key: TypeKey
  label: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchPanel',
  setup(__props) {

const mainStore = useMainStore()

const {
  searchWord,
  replaceWord,
  searchResults,
  searchIndex,
  modifiers,
  searchNext,
  searchPrev,
  replace,
  replaceAll,
  toggleModifiers,
} = useSearch()

const type = ref<TypeKey>('search')
const tabs: TabItem[] = [
  { key: 'search', label: '查找' },
  { key: 'replace', label: '替换' },
]

const close = () => {
  mainStore.setSearchPanelState(false)
}

const searchInpRef = ref<InstanceType<typeof Input>>()
onMounted(() => {
  searchInpRef.value!.focus()
})

watch(type, () => {
  nextTick(() => {
    searchInpRef.value!.focus()
  })
})

return (_ctx: any,_cache: any) => {
  const _component_IconClose = _resolveComponent("IconClose")!
  const _component_IconLeft = _resolveComponent("IconLeft")!
  const _component_IconRight = _resolveComponent("IconRight")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(MoveablePanel, {
    class: "search-panel",
    width: 330,
    height: 0,
    left: -270,
    top: 90
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "close-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (close())),
        onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createVNode(_component_IconClose)
      ], 32),
      _createVNode(Tabs, {
        tabs: tabs,
        value: type.value,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((type).value = $event))
      }, null, 8, ["value"]),
      _createElementVNode("div", {
        class: _normalizeClass(["content", type.value]),
        onMousedown: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createVNode(Input, {
          class: "input",
          value: _unref(searchWord),
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_isRef(searchWord) ? (searchWord).value = $event : null)),
          placeholder: "输入查找内容",
          onEnter: _cache[7] || (_cache[7] = ($event: any) => (_unref(searchNext)())),
          ref_key: "searchInpRef",
          ref: searchInpRef
        }, {
          suffix: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(searchIndex) + 1) + "/" + _toDisplayString(_unref(searchResults).length), 1),
            _createVNode(Divider, { type: "vertical" }),
            _withDirectives((_openBlock(), _createElementBlock("span", {
              class: _normalizeClass(["ignore-case", { 'active': _unref(modifiers) === 'g' }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(toggleModifiers)()))
            }, [
              _createTextVNode("Aa")
            ], 2)), [
              [_directive_tooltip, '忽略大小写']
            ]),
            _createVNode(Divider, { type: "vertical" }),
            _withDirectives(_createVNode(_component_IconLeft, {
              class: "next-btn left",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(searchPrev)()))
            }, null, 512), [
              [_directive_tooltip, '上一个']
            ]),
            _withDirectives(_createVNode(_component_IconRight, {
              class: "next-btn right",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(searchNext)()))
            }, null, 512), [
              [_directive_tooltip, '下一个']
            ])
          ]),
          _: 1
        }, 8, ["value"]),
        (type.value === 'replace')
          ? (_openBlock(), _createBlock(Input, {
              key: 0,
              class: "input",
              value: _unref(replaceWord),
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_isRef(replaceWord) ? (replaceWord).value = $event : null)),
              placeholder: "输入替换内容",
              onEnter: _cache[9] || (_cache[9] = ($event: any) => (_unref(replace)()))
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        (type.value === 'replace')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(Button, {
                disabled: !_unref(searchWord),
                style: {"margin-left":"5px"},
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(replace)()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("替换")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(Button, {
                disabled: !_unref(searchWord),
                type: "primary",
                style: {"margin-left":"5px"},
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(replaceAll)()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("全部替换")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true)
      ], 34)
    ]),
    _: 1
  }))
}
}

})